<template>
  <!--底部按钮-->
  <transition name="fade">
    <div v-if="buttonInfo?.Generate" class="work-flow-bottom-btn actionbar">
      <div class="discount-box" v-show="containPaidNode">80% Off</div>
      <div class="work-flow-bottom-btn-main-text" @click.stop="handleGenerate">
        {{ buttonInfo?.Generate }}
        <div class="tag-tips-icon" v-show="!isFreeCreate" v-tooltip.top="{
          value: buttonInfo?.workFlow31,
          pt: {
            arrow: {
              style: {
                borderTopColor: 'rbg(48,49,51)',
              }
            },
            text: { // tooltip 文本样式
              class: 'custom-tooltip-text',
              style: {
                color: '#fff',
                fontSize: '14px',
                backgroundColor: 'rbg(48,49,51)',
              }
            }
          }
        }">
          <img src="@/assets/images/tagTips.png" alt="">
        </div>
      </div>
      <div class="work-flow-bottom-btn-free-create" @click.stop="
        () => {
          isFreeCreate = !isFreeCreate;
          freeCreateChange(isFreeCreate);
        }
      ">
        <span class="free-create-text" :style="{color: !isFreeCreate ? '#A2A2A2' : '#fff'}">{{ buttonInfo?.daily_rights_2 }}</span>
        <ToggleSwitch @click.stop v-model="isFreeCreate" @change="() => freeCreateChange(isFreeCreate)" />
      </div>
      <!-- </div> -->
    </div>
  </transition>
</template>

<script lang="ts" setup>
import ToggleSwitch from 'primevue/toggleswitch';

import { ref } from 'vue'
interface ButtonInfo {
  Generate: string;
  daily_rights_2: string;
  workFlow31: string;
}

const buttonInfo = ref<ButtonInfo | null>(null)
const containPaidNode = ref(false)
const isFreeCreate = ref(true)

// 监听来自iframe的消息
window.addEventListener('message', (event) => {
  // 安全检查：确保消息来源可信
  if (event.origin !== location.origin) {
    return;
  }

  const { type, data } = event.data;
  // 处理不同类型的消息
  switch (type) {
    case 'initData':
      buttonInfo.value = data;
      isFreeCreate.value = data.isFreeCreate;
      // 处理特定类型的消息
      break;
    // ... 其他消息类型的处理
  }
});

// 点击创作传递给iframe
const handleGenerate = () => {
  (top as any).postMessage({ type: 'handleGenerate' }, '*')
}
// 切换后把数据传递给iframe
const freeCreateChange = (value: boolean) => {
  (top as any).postMessage({ type: 'freeCreateChange',info: value }, '*')
}
</script>

<style scoped>
.actionbar {
  position: fixed;
  z-index: 1000;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
}

.work-flow-bottom-btn {
  min-width: 461px;
  height: 68px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(51, 51, 51, 0.6);
  border-radius: 16px;
  box-sizing: border-box;
  z-index: 10;
}

.discount-box {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 10px;
  transform: translate(10%, -50%);
  box-sizing: border-box;
  height: 25px;
  background: linear-gradient(129deg, #ffdb93 0%, #ffbf56 100%);
  box-shadow: inset 0px 0px 6px 0px rgba(255, 212, 149, 0.6);
  border-radius: 12px 5px 12px 0px;
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 13px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.work-flow-bottom-btn-main-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  width: 285px;
  height: 48px;
  background: linear-gradient(99deg, #3271cc 0%, #0fffff 100%);
  border-radius: 12px 12px 12px 12px;
  font-weight: bold;
  font-size: 16px;
  color: #fff;

}

.work-flow-bottom-btn-main-text .tag-tips-icon {
  margin-left: 5px;
  padding: 4px 0;
}

.work-flow-bottom-btn-main-text img {
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
}

.work-flow-bottom-btn-main-sub-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 12px;
  color: #fcfcfc;
  line-height: 18px;
}

.work-flow-bottom-btn-free-create {
  flex: 1;
  font-family: Inter, Inter;
  font-weight: 500;
  height: 48px;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.free-create-text {
  margin-right: 5px;
}

.work-flow-bottom-btn-free-create .free-create-text {
  margin-right: 5px;
}

:deep(.p-toggleswitch) {
  width: 36px;
  height: 20px;
}

:deep(.p-toggleswitch-handle) {
  width: 16px;
  height: 16px;
  inset-inline-start: 2px;
  margin-block-start: -8px;
}

:deep(.p-toggleswitch.p-toggleswitch-checked .p-toggleswitch-handle) {
  background: #fff;
  inset-inline-start: 18px;
}

:deep(.p-toggleswitch.p-toggleswitch-checked .p-toggleswitch-slider) {
  background: linear-gradient( 99deg, #3271CC 0%, #0FFFFF 100%);
  /* border-style: hidden; */
  border-style: hidden;

}
</style>
